import { render, staticRenderFns } from "./NowInfinityLogo.vue?vue&type=template&id=d001999c&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d001999c')) {
      api.createRecord('d001999c', component.options)
    } else {
      api.reload('d001999c', component.options)
    }
    module.hot.accept("./NowInfinityLogo.vue?vue&type=template&id=d001999c&", function () {
      api.rerender('d001999c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/NowInfinityLogo.vue"
export default component.exports